export default "__VITE_ASSET__BxX16ggF__"